export enum ConfirmButtonId {
  UPDATE = "update",
  RESTART = "restart",
  REBOOT = "reboot",
}

export interface InitialFormValues {
  volume: number | undefined;
  master: number | undefined;
  appLockPin: string | undefined;
  appLock: boolean;
  wakeSleep: boolean;
  startDate: string | undefined;
  endDate: string | undefined;
}
